import React, { useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";

const TimeSeriesMonthlyComponent = (props) => {
  const history = useHistory();

  useEffect(() => {
    (async () => {
      await localStorage.setItem("skygeni-user-page", "Growth Modeling");
      await localStorage.setItem(
        "skygeni-user-growthModelingPage",
        "Time Series projection of Closed Won (Monthly)"
      );
      await localStorage.removeItem("skygeni-user-repPage");
      await localStorage.removeItem("skygeni-user-productPage");
    await localStorage.removeItem("skygeni-user-SettingsPage");
    await localStorage.removeItem("skygeni-user-pipelineProgressionPage");
    await localStorage.removeItem("skygeni-user-pipelineVelocityandConversionPage")
    await localStorage.removeItem("skygeni-user--pipelineBuildandSuficencyPage")
    await localStorage.removeItem("skygeni-user-marketIntelandGrowthLeversPage");
    await localStorage.removeItem("skygeni-user-salesProductivityPage");
    await localStorage.removeItem("skygeni-user-growthScienceInsightsPage");
    await localStorage.removeItem("skygeni-user-personalizedScorecardsPage");
      await localStorage.setItem(
        "params",
        JSON.stringify(props.match.params.filters)
      );
      history.push("/");
      window.location.reload();
    })();
  }, []);

  return <div style={{ margin: "1rem auto" }}>Loading...</div>;
};
let routerAddedTimeSeriesMonthlyComponent = withRouter(
    TimeSeriesMonthlyComponent
);
export default routerAddedTimeSeriesMonthlyComponent;
